import { BusinessProfile } from '@oy/types';
import {
  AUTH_PREFIX,
  getBusinessProfile,
  getUpgradeAccountBusinessType,
} from 'src/clients';
import useSWR from 'swr/immutable';
import { useAppSelector } from '../useAppSelector';

const initialState: BusinessProfile = {
  address: '',
  brand_name: '',
  company_name: '',
  industry: '',
  phone_number: '',
  email: '',
  npwp_number: '',
  pic_phone_number: '',
  pic_email: '',
  pic_name: '',
  country_of_incorporation: '',
  date_of_incorporation: '',
  country_of_headquarter: '',
  status: '',
  message: '',
  business_type: '',
};

export const useBusinessProfileData = () => {
  const auth = useAppSelector(state => state.auth);
  const { data, ...props } = useSWR(
    !auth.isSessionExpired ? `${AUTH_PREFIX}/account/business-profile` : null,
    () => getBusinessProfile().then(res => res.data.data),
    { revalidateOnMount: true },
  );

  return { data: data ?? initialState, ...props };
};

export const useBusinessTypeData = () => {
  const auth = useAppSelector(state => state.auth);
  const { data, ...props } = useSWR(
    !auth.isSessionExpired ? `${AUTH_PREFIX}/account/business-type` : null,
    () => getUpgradeAccountBusinessType().then(res => res.data.data),
    {
      revalidateOnMount: true,
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );

  return { data: data ?? initialState, ...props };
};
